export const tolerantPromiseAll = async (promises: any[]) =>
  Promise.all(promises.map(p => p.catch(() => undefined)))
